import { transport } from 'config/transport';

export function callApiImportStudents(classId, formData) {
    return transport.post(`/mamnon/classes/${classId}/importstudent`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}
